export const isEqual = (string1: string, string2: string) =>
  string1.toString().toLocaleLowerCase() ===
  string2.toString().toLocaleLowerCase();
